
import React, { useState, useEffect, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { FaPrint } from 'react-icons/fa';
import  { ButtonGroup, EditButton} from './../Utils/StyledComponents.jsx';

const VerRetornos = React.forwardRef((props, ref) => {
    const navigate = useNavigate();
    const { idCabezaFamilia, rol, token, Cargando, setCargando, Mensaje, fetchData } = props;
    const [retornos, setRetornos] = useState([]);
    const ImprimirCompleto = (row) => {
        navigate(`/retornos/imprimirformatocompleto/${row.id}/${idCabezaFamilia}`)
    };
    
    const fetchRetornos = async () => {
        const data = await fetchData(idCabezaFamilia, rol);
        setRetornos(data);
    };

    useEffect(() => {
        fetchRetornos();
    }, [idCabezaFamilia, rol]);

    // Expose fetchRetornos to the parent
    useImperativeHandle(ref, () => ({
        refresh: fetchRetornos,
    }));
    return (
        <div className="container-fluid">   
            <div className="row">
                <div className="col-md-12">
                    <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                        <h5>Retornos recibidos</h5>
                        <table className="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>Acciones</th>
                                    <th>Id</th>
                                    <th>Fecha entrevista</th>
                                    <th>Fecha visita domiciliaria</th>
                                    <th>Estado</th>
                                    <th>Personas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {retornos.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No hay datos para mostrar
                                        </td>
                                    </tr>
                                ) : (
                                    retornos.map((row, idx) => (
                                        <tr key={row.id || idx}>
                                            <td>
                                                <ButtonGroup>
                                                    <EditButton
                                                        type="button"
                                                        onClick={() => ImprimirCompleto(row)}
                                                        data-tooltip-id="tooltiparriba"
                                                        data-tooltip-content="Imprimir completo"
                                                    >
                                                        <FaPrint />
                                                    </EditButton>
                                                </ButtonGroup>
                                            </td>
                                            <td>{row.id}</td>
                                            <td>
                                                {row.ret_fechaentrevista
                                                    ? (() => {
                                                        const date = new Date(row.ret_fechaentrevista);
                                                        return !Number.isNaN(date.getTime())
                                                            ? date.toISOString().split('T')[0]
                                                            : row.ret_fechaentrevista;
                                                    })()
                                                    : ''}
                                            </td>
                                            <td>
                                                {row.ret_fechavisitadomiciliaria
                                                    ? (() => {
                                                        const date = new Date(row.ret_fechavisitadomiciliaria);
                                                        return !Number.isNaN(date.getTime())
                                                            ? date.toISOString().split('T')[0]
                                                            : row.ret_fechavisitadomiciliaria;
                                                    })()
                                                    : ''}
                                            </td>
                                            <td>{row.estado}</td>
                                            <td>{row.personas}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default VerRetornos;